import React, { useState } from 'react'
import { TextField } from '@nike/eds'

import { Section } from '../components/Section.js'

export default function ParamDebugger() {
  const [uri, setUri] = useState('')
  const params = uri && parseParams(uri)
  return (
    <Section title='Authorize Request Debugger'>
      <TextField value={uri} onChange={e => setUri(e.target.value)} />
      {params && <pre>{JSON.stringify(params, null, 2)}</pre>}
    </Section>
  )
}

function parseParams(uri) {
  try {
    return Object.fromEntries(new URL(uri).searchParams.entries())
  } catch (e) {
    console.error('uri parsing error', e)
    return null
  }
}
